<button mat-icon-button (click)="copyLink()" [matTooltip]="'Copy link' | trans">
    <mat-icon svgIcon="copy-link"></mat-icon>
</button>